(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["resenas-videos"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('review-video-gallery')) {
    customElements.define('review-video-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.rv__track');
        const videos = this.querySelectorAll('video');
        this.querySelectorAll('[data-direction]').forEach(button => {
          button.addEventListener('click', () => {
            const card = track.querySelector('.rv__card:not([hidden])');
            if (!card) return;
            const step = card.getBoundingClientRect().width + parseFloat(getComputedStyle(track).gap);
            track.scrollBy({ left: step * Number(button.dataset.direction), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          });
        });
        videos.forEach(video => {
          const button = video.parentElement.querySelector('.rv__play');
          button.addEventListener('click', async () => {
            try { await video.play(); } catch { button.hidden = false; }
          });
          video.addEventListener('play', () => {
            button.hidden = true;
            videos.forEach(other => { if (other !== video) other.pause(); });
          });
          video.addEventListener('pause', () => { button.hidden = false; });
          video.addEventListener('ended', () => { button.hidden = false; });
        });
      }
      disconnectedCallback() { this.querySelectorAll('video').forEach(video => video.pause()); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virelia-crema-gua-sha"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('virelia-cream-product')) {
  customElements.define('virelia-cream-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        this.querySelectorAll('[data-slide]').forEach(slide => {
          slide.hidden = slide.dataset.slide !== thumb.dataset.thumb;
        });
        this.querySelectorAll('[data-thumb]').forEach(button => {
          button.setAttribute('aria-pressed', String(button === thumb));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virelia-mascarillas"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('virelia-mask-product')) {
  customElements.define('virelia-mask-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        this.querySelectorAll('[data-slide]').forEach(slide => {
          slide.hidden = slide.dataset.slide !== thumb.dataset.thumb;
        });
        this.querySelectorAll('[data-thumb]').forEach(button => {
          button.setAttribute('aria-pressed', String(button === thumb));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virelia-nida-mexico"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('virelia-nida-product')) {
  customElements.define('virelia-nida-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        this.querySelectorAll('[data-slide]').forEach(slide => {
          slide.hidden = slide.dataset.slide !== thumb.dataset.thumb;
        });
        this.querySelectorAll('[data-thumb]').forEach(button => {
          button.setAttribute('aria-pressed', String(button === thumb));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virelia-producto"] && !Shopify.designMode) return;
  try {
    

function iniciarContadorVirelia() {
  document.querySelectorAll('.vb-countdown').forEach(contador => {
    if (contador.dataset.iniciado === 'true') return;
    contador.dataset.iniciado = 'true';

    let intervalo;

    function actualizar() {
      const fin = new Date(contador.dataset.end).getTime();
      const restante = Math.max(0, fin - Date.now());

      if (!Number.isFinite(fin)) {
        contador.textContent = 'Fecha no válida';
        return;
      }

      if (restante === 0) {
        contador.hidden = true;
        const aviso = contador.parentElement.querySelector('.vb-countdown-ended');
        if (aviso) aviso.hidden = false;
        clearInterval(intervalo);
        return;
      }

      const dias = Math.floor(restante / 86400000);
      const horas = Math.floor((restante / 3600000) % 24);
      const minutos = Math.floor((restante / 60000) % 60);
      const segundos = Math.floor((restante / 1000) % 60);

      const dosDigitos = n => String(n).padStart(2, '0');

     
const numeros = contador.querySelectorAll('.vb-time-number');

if (numeros.length === 4) {
  numeros[0].textContent = dosDigitos(dias);
  numeros[1].textContent = dosDigitos(horas);
  numeros[2].textContent = dosDigitos(minutos);
  numeros[3].textContent = dosDigitos(segundos);
}

    }

    actualizar();
    intervalo = setInterval(actualizar, 1000);
  });
}

iniciarContadorVirelia();
document.addEventListener('shopify:section:load', iniciarContadorVirelia);

if (!customElements.get('virelia-product')) {
  customElements.define('virelia-product', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      
const sticky = this.querySelector('.vb-sticky-buy');
const mainButton = this.querySelector('.vb-cart');
const stickyButton = this.querySelector('.vb-sticky-button');
const productForm = mainButton?.closest('form');

if (sticky && mainButton && stickyButton && productForm) {
  const observer = new IntersectionObserver(([entry]) => {
    const passedButton = entry.boundingClientRect.bottom < 0;
    sticky.hidden = entry.isIntersecting || !passedButton;
  }, { threshold: 0 });

  observer.observe(mainButton);

  stickyButton.addEventListener('click', async () => {
    const selected = productForm.querySelector('input[name="id"]:checked');

    if (!selected || selected.disabled) {
      alert('Selecciona un pack disponible.');
      return;
    }

    stickyButton.disabled = true;
    stickyButton.textContent = 'PROCESANDO...';

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: Number(selected.value),
          quantity: 1
        })
      });

      if (!response.ok) {
        throw new Error('No se pudo agregar el pack.');
      }

      window.location.href = root + 'checkout';

    } catch (error) {
      stickyButton.disabled = false;
      stickyButton.textContent = '¡LO QUIERO! →';
      alert('No hemos podido procesar tu pedido. Inténtalo de nuevo.');
    }
  });
}
 
      this.addEventListener('click', event => {
        const thumb = event.target.closest('[data-thumb]');
        if (!thumb || !this.contains(thumb)) return;
        this.querySelectorAll('[data-slide]').forEach(slide => {
          slide.hidden = slide.dataset.slide !== thumb.dataset.thumb;
        });
        this.querySelectorAll('[data-thumb]').forEach(button => {
          button.setAttribute('aria-pressed', String(button === thumb));
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["virelia-resenas-fotos"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('virelia-photo-reviews')){
  customElements.define('virelia-photo-reviews',class extends HTMLElement{
    connectedCallback(){
      if(this.initialized)return;
      this.initialized=true;
      this.querySelectorAll('[data-step]').forEach(button=>button.addEventListener('click',()=>{
        const track=this.querySelector('.vpr-track');
        const card=track.querySelector('.vpr-card');
        if(!card)return;
        const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);
        track.scrollBy({left:step*Number(button.dataset.step),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
      }));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
